import { render, staticRenderFns } from "./Cooling.vue?vue&type=template&id=011405f6&scoped=true&"
import script from "./Cooling.vue?vue&type=script&lang=ts&"
export * from "./Cooling.vue?vue&type=script&lang=ts&"
import style0 from "./Cooling.vue?vue&type=style&index=0&id=011405f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011405f6",
  null
  
)

export default component.exports